import { render, staticRenderFns } from "./EnrollmentPage.vue?vue&type=template&id=101d8fde&"
import script from "./EnrollmentPage.vue?vue&type=script&lang=ts&"
export * from "./EnrollmentPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports